var map = {
	"./Sticker_icon/800-super-Gaea-logo.png": 6938,
	"./Sticker_icon/About-Us-PNG-HD.png": 4638,
	"./Sticker_icon/Cintri-cambodia-logo.png": 9677,
	"./Sticker_icon/ClearCambodiaLogo.jpg": 4466,
	"./Sticker_icon/ODC-New-logo.png": 1884,
	"./Sticker_icon/arrows.png": 5527,
	"./Sticker_icon/how-to-recycle.png": 9555,
	"./Sticker_icon/information.png": 2550,
	"./Sticker_icon/logo.webp": 9510,
	"./Sticker_icon/mizuda-logo.jpg": 81,
	"./Sticker_icon/trust-comm-members.png": 8862,
	"./Sticker_icon/waste-summit-cambodia-logo.png": 287,
	"./anti-logo.png": 1723,
	"./anti-waste-logo.png": 5146,
	"./antiwaste-logo.png": 4739,
	"./event/E-waste.png": 8742,
	"./event/Frame 35.png": 8756,
	"./event/WasteManagement.jpg": 2538,
	"./event/glass.png": 3677,
	"./event/image 2.png": 9474,
	"./event/image 20.png": 7964,
	"./event/image 3 (1).png": 9852,
	"./event/image 39 (2).png": 1877,
	"./event/image 40 (2).png": 845,
	"./event/image 41 (2).png": 1198,
	"./event/image 42 (2).png": 4347,
	"./event/image 43 (2).png": 6090,
	"./event/image 44 (1).png": 9624,
	"./event/image 9.png": 8095,
	"./event/image-removebg-preview.png": 28,
	"./event/mental.png": 4572,
	"./event/pana.png": 5691,
	"./event/paper.png": 4732,
	"./event/paperwaste.png": 7465,
	"./event/plastic.png": 6437,
	"./event/pngguru 2.png": 5549,
	"./event/textile.png": 794,
	"./event/waste.jpg": 148,
	"./event/waste.png": 6974,
	"./image 2.png": 3115,
	"./image 20.png": 2286,
	"./logo-antiwaste.png": 9381,
	"./logo.png": 6949,
	"./logo.svg": 9574,
	"./logos/image 38 (1).png": 5415,
	"./logos/image 39 (1).png": 3925,
	"./logos/image 40 (1).png": 629,
	"./logos/image 41.png": 8590,
	"./logos/image 42 (1).png": 4964,
	"./logos/image 43 (1).png": 8548,
	"./logos/image 45.png": 205,
	"./logos/image 46.png": 3041,
	"./logos/image 47.png": 5619,
	"./metal.jpg": 553,
	"./recycle.jpg": 3609,
	"./recycledproduct/7884850_3725847.jpg": 2661,
	"./recycledproduct/Frame 31.png": 8576,
	"./recycledproduct/image 2.png": 8207,
	"./recycledproduct/image 33.png": 8475,
	"./recycledproduct/image 34.png": 6361,
	"./recycledproduct/image 36.png": 3654,
	"./recycledproduct/image_cover.jpg": 2152,
	"./recycledproduct/pngguru 2.png": 3875,
	"./recycling.jpg": 8430,
	"./shopping-card.png": 7206,
	"./slideshow/images.jpeg": 1266,
	"./tailwind.css": 1356,
	"./waste-facilities-002.png": 4256,
	"./waste/images.jpeg": 4080
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;